import _ from 'lodash';

export const selectCommonAreaAssetForm = state => _.get(state, ['commonAreaAssetForm'], {});

export const selectCommonAreaAssetFormData = state => _.get(selectCommonAreaAssetForm(state), ['data'], {});
